import axios from '../../../axios';
import IClientFile from '../types/IClientFile';

const url = 'invoicingservice/api/client-file/';

export const saveClientFile = (payload: IClientFile) => axios.post(`${url}save-file`, payload);

export const getClientFilesByClientId = (id: string) => axios.get(`${url}by-client-id/${id}`);

export const getClientContactFilesByContactId = (id: string) =>
  axios.get(`${url}by-contact-id/${id}`);
